import {apiFetch, checkStatus, objectToFormData, objectToQueryParameters} from "./commons";
//import { isArrayWithLength} from "../../helpers/commons";

function getConfig() {
   
   return apiFetch('/config', {
	  accept: "application/json"
   })
   .then(checkStatus);

}

function getUserAuthState() {
	  
	return apiFetch('/auth', {
		accept: "application/json"
	})
	.then(checkStatus);
	
}

function updateLanguage(data) {

	var form = objectToFormData(data);
	
	return apiFetch('/lang', {
		method: 'post',
		body: form
	})
	.then(checkStatus);
}

function loginUser(data) {

	var form = objectToFormData(data);

	return apiFetch('/login', {
	    method: 'post',
		body: form
   })
   .then(checkStatus);
}

function logoutUser() {

	var form = new FormData();

	return apiFetch('/logout', {
	    method: 'post',
		body: form
   })
   .then(checkStatus);
}

function changeUserPassword(data) {

	var form = objectToFormData(data);
	return apiFetch('/pwd/change', {
		method: 'PATCH',
		body: form
	})
	.then(checkStatus)
}

function selectSchool(data) {

	var form = objectToFormData(data);
	return apiFetch('/select-school', {
		method: 'POST',
		body: form
	})
	.then(checkStatus)
}

function sendUserPasswordResetEmail(data) {

	var form = objectToFormData(data);

	return apiFetch('/pwd/recover', {
	    method: 'post',
		body: form
   })
   .then(checkStatus);
}

function confirmUserPasswordReset(data) {

	var form = objectToFormData(data);

	return apiFetch('/pwd/reset', {
		method: 'PATCH',
		body: form
	})
   .then(checkStatus);
}

function verifyUserPasswordResetToken(data) {
	var form = objectToFormData(data);

	return apiFetch('/pwd/token', {
		method: 'post',
		body: form
	})
   .then(checkStatus);
}

/** Valida invitationToken sem consumir. Landing /invite/:token chama pra decidir
 *  se mostra form ou redirect. Retorna { success, firstName } quando válido. */
function verifyInvitationToken(data) {
	var form = objectToFormData(data);

	return apiFetch('/invite/verify', {
		method: 'post',
		body: form
	})
   .then(checkStatus);
}

/** Accept invite = define senha + auto-login. Backend retorna { status, userData }
 *  igual ao loginUser — auth store popula direto, redirect pra home sem passar
 *  pela tela de login. */
function acceptInvite(data) {
	var form = objectToFormData(data);

	return apiFetch('/invite/accept', {
		method: 'post',
		body: form
	})
   .then(checkStatus);
}


const loginApi = { getConfig, updateLanguage, getUserAuthState, loginUser, logoutUser, changeUserPassword, selectSchool,
		sendUserPasswordResetEmail, confirmUserPasswordReset, verifyUserPasswordResetToken,
		verifyInvitationToken, acceptInvite};

export default loginApi;